export const functionalitiesPage = {
  // SEO
  'functionalitiesPage.seo.title': 'Fonctionnalités Subvention360 - Plateforme de gestion des aides publiques',
  'functionalitiesPage.seo.description': 'Découvrez les fonctionnalités de Subvention360 : {count}+ aides, matching automatique, suivi des dossiers, collaboration d\'équipe et export PDF professionnel.',
  'functionalitiesPage.seo.keywords': 'fonctionnalités subvention360, plateforme aides publiques, matching subventions, gestion subventions, export PDF',

  // Header Navigation
  'functionalitiesPage.nav.features': 'Fonctionnalités',
  'functionalitiesPage.nav.pricing': 'Tarifs',
  'functionalitiesPage.nav.login': 'Connexion',
  'functionalitiesPage.nav.trial': 'Essai',
  'functionalitiesPage.nav.dashboard': 'Tableau de bord',

  // Hero Section
  'functionalitiesPage.hero.title': 'Plateforme Subvention360',
  'functionalitiesPage.hero.subtitle': 'Tous les outils pour maîtriser les financements publics en un seul endroit',
  'functionalitiesPage.hero.description': 'Une suite complète conçue spécifiquement pour les professionnels du conseil, de l\'audit et de l\'expertise comptable.',
  'functionalitiesPage.hero.pricing': 'À partir de 49€/mois',
  'functionalitiesPage.hero.viewPricing': 'Voir tous les tarifs →',

  // Demo Carousel
  'functionalitiesPage.demo.title': 'Découvrez la plateforme en action',
  'functionalitiesPage.demo.subtitle': 'Cliquez sur chaque fonctionnalité pour voir comment ça marche',
  'functionalitiesPage.demo.siret.title': 'Création de fiche client',
  'functionalitiesPage.demo.siret.description': 'Entrez un SIRET et récupérez automatiquement les informations de l\'entreprise',
  'functionalitiesPage.demo.assistant.title': 'Assistant IA',
  'functionalitiesPage.demo.assistant.description': 'Posez vos questions et laissez l\'IA vous guider dans vos recherches',
  'functionalitiesPage.demo.search.title': 'Recherche d\'aides',
  'functionalitiesPage.demo.search.description': 'Filtrez par région, secteur, montant et trouvez les dispositifs adaptés',
  'functionalitiesPage.demo.matching.title': 'Score d\'éligibilité',
  'functionalitiesPage.demo.matching.description': 'Chaque aide est notée de 0 à 100% selon le profil de votre client',
  'functionalitiesPage.demo.export.title': 'Export PDF',
  'functionalitiesPage.demo.export.description': 'Générez des rapports professionnels avec votre logo et coordonnées',
  'functionalitiesPage.demo.email.title': 'Envoi par email',
  'functionalitiesPage.demo.email.description': 'Email personnalisé généré par IA avec le rapport en pièce jointe',
  'functionalitiesPage.demo.placeholder': 'GIF de démonstration à ajouter',

  // Overview Features
  'functionalitiesPage.overview.database.title': 'Base de données complète',
  'functionalitiesPage.overview.database.description': '{count}+ financements français et européens, actualisés chaque semaine',
  'functionalitiesPage.overview.identification.title': 'Identification Automatique',
  'functionalitiesPage.overview.identification.description': 'Trouvez les aides éligibles pour chaque client en quelques secondes',
  'functionalitiesPage.overview.tracking.title': 'Suivi des Dossiers',
  'functionalitiesPage.overview.tracking.description': 'Tableau de bord pour piloter toutes vos missions de financement',
  'functionalitiesPage.overview.security.title': 'Sécurité Renforcée',
  'functionalitiesPage.overview.security.description': 'RGPD, hébergement EU sécurisé, chiffrement des données',

  // Capabilities Table
  'functionalitiesPage.capabilities.title': 'Tableau des Capacités de la Plateforme',
  'functionalitiesPage.capabilities.subtitle': 'Spécifications techniques et performances garanties',
  'functionalitiesPage.capabilities.feature': 'Fonctionnalité',
  'functionalitiesPage.capabilities.capacity': 'Capacité',
  'functionalitiesPage.capabilities.detail': 'Détail',

  'functionalitiesPage.capabilities.database.feature': 'Base de données',
  'functionalitiesPage.capabilities.database.capacity': '{count}+ financements',
  'functionalitiesPage.capabilities.database.detail': 'Subventions, prêts, avances, CIR, allègements fiscaux',

  'functionalitiesPage.capabilities.update.feature': 'Mise à jour',
  'functionalitiesPage.capabilities.update.capacity': 'Hebdomadaire',
  'functionalitiesPage.capabilities.update.detail': 'Nouveaux dispositifs et modifications',

  'functionalitiesPage.capabilities.clients.feature': 'Fiches clients',
  'functionalitiesPage.capabilities.clients.capacity': '2 types + import',
  'functionalitiesPage.capabilities.clients.detail': 'SIRET, projet de création, ou import Excel/CSV',

  'functionalitiesPage.capabilities.ai.feature': 'Assistant IA',
  'functionalitiesPage.capabilities.ai.capacity': 'Intégré',
  'functionalitiesPage.capabilities.ai.detail': 'Questions, aide à la rédaction, guide création',

  'functionalitiesPage.capabilities.score.feature': 'Score d\'éligibilité',
  'functionalitiesPage.capabilities.score.capacity': 'Automatique',
  'functionalitiesPage.capabilities.score.detail': 'Note de 0 à 100% par aide',

  'functionalitiesPage.capabilities.tracking.feature': 'Suivi des dossiers',
  'functionalitiesPage.capabilities.tracking.capacity': 'Tableau de bord',
  'functionalitiesPage.capabilities.tracking.detail': 'Par client ou par mission',

  'functionalitiesPage.capabilities.team.feature': 'Travail en équipe',
  'functionalitiesPage.capabilities.team.capacity': 'Multi-collaborateurs',
  'functionalitiesPage.capabilities.team.detail': 'Droits d\'accès par rôle',

  'functionalitiesPage.capabilities.reports.feature': 'Rapports & Email',
  'functionalitiesPage.capabilities.reports.capacity': 'PDF + envoi IA',
  'functionalitiesPage.capabilities.reports.detail': 'Logo, coordonnées, contenu email généré',

  'functionalitiesPage.capabilities.compliance.feature': 'Conformité',
  'functionalitiesPage.capabilities.compliance.capacity': 'RGPD',
  'functionalitiesPage.capabilities.compliance.detail': 'Données hébergées en Europe',

  'functionalitiesPage.capabilities.support.feature': 'Support',
  'functionalitiesPage.capabilities.support.capacity': 'Email',
  'functionalitiesPage.capabilities.support.detail': 'Réponse sous 48h ouvrées',

  // Search & Discovery Section
  'functionalitiesPage.search.title': 'Recherche & Découverte Intelligente',
  'functionalitiesPage.search.subtitle': 'Base de données exhaustive de {count}+ financements publics',
  'functionalitiesPage.search.weekly.title': 'Base actualisée chaque semaine',
  'functionalitiesPage.search.weekly.description': 'Nouveaux dispositifs, modifications de critères et dates limites toujours à jour.',
  'functionalitiesPage.search.weekly.feature1': 'Recherche par plusieurs critères simultanés',
  'functionalitiesPage.search.weekly.feature2': 'Filtres par secteur d\'activité, région, montant, type d\'aide',
  'functionalitiesPage.search.smart.title': 'Recherche qui comprend votre métier',
  'functionalitiesPage.search.smart.description': 'Tapez "embauche jeune" et trouvez aussi "contrat d\'apprentissage", "aide premier emploi", etc.',
  'functionalitiesPage.search.smart.feature1': 'Aides nationales, régionales et européennes',
  'functionalitiesPage.search.smart.feature2': 'Notification quand de nouveaux dispositifs correspondent à vos clients',

  // AI Analysis Section
  'functionalitiesPage.ai.title': 'Analyse Automatique des Profils',
  'functionalitiesPage.ai.subtitle': 'Les aides adaptées à chaque client, identifiées automatiquement',
  'functionalitiesPage.ai.score.title': 'Score d\'éligibilité clair',
  'functionalitiesPage.ai.score.description': 'Chaque aide est notée de 0 à 100% selon la correspondance avec le profil de votre client.',
  'functionalitiesPage.ai.score.feature1': 'Priorisez les dossiers avec le meilleur potentiel',
  'functionalitiesPage.ai.score.feature2': 'Les aides les plus pertinentes en haut de liste',
  'functionalitiesPage.ai.history.title': 'Historique de vos dossiers',
  'functionalitiesPage.ai.history.description': 'Gardez une trace des candidatures passées et des résultats obtenus pour chaque client.',
  'functionalitiesPage.ai.history.feature1': 'Suivi des dossiers acceptés et refusés',
  'functionalitiesPage.ai.history.feature2': 'Montants obtenus par client et par année',
  'functionalitiesPage.ai.history.feature3': 'Statistiques pour valoriser votre accompagnement',
  'functionalitiesPage.ai.time.title': 'Gain de temps concret',
  'functionalitiesPage.ai.time.description': 'Passez de 2-3 heures de recherche par client à quelques minutes.',
  'functionalitiesPage.ai.time.feature1': 'Identification des aides en quelques secondes',
  'functionalitiesPage.ai.time.feature2': 'Plus de temps pour le conseil à valeur ajoutée',

  // Tracking Section
  'functionalitiesPage.tracking.title': 'Suivi de Vos Missions',
  'functionalitiesPage.tracking.subtitle': 'Tableau de bord pour piloter tous vos dossiers de financement',
  'functionalitiesPage.tracking.overview.title': 'Vue d\'ensemble de votre activité',
  'functionalitiesPage.tracking.overview.feature1': 'Montant total des financements en cours et nombre de dossiers actifs',
  'functionalitiesPage.tracking.overview.feature2': 'Alertes automatiques pour les échéances à moins de 7 jours',
  'functionalitiesPage.tracking.kanban.title': 'Tableau en 3 colonnes : À Étudier, En Préparation, Déposé',
  'functionalitiesPage.tracking.kanban.feature1': 'Déplacez vos dossiers d\'une étape à l\'autre en un clic',
  'functionalitiesPage.tracking.kanban.feature2': 'Montant, client et prochaine action visibles sur chaque dossier',

  // Collaboration Section
  'functionalitiesPage.collaboration.title': 'Collaboration d\'Équipe Avancée',
  'functionalitiesPage.collaboration.subtitle': 'Environnement de travail collaboratif sécurisé',
  'functionalitiesPage.collaboration.sharing.title': 'Partagez le travail entre collaborateurs',
  'functionalitiesPage.collaboration.sharing.feature1': 'Chaque collaborateur accède à ses clients et dossiers',
  'functionalitiesPage.collaboration.sharing.feature2': 'Droits d\'accès configurables : lecture seule, modification, administration',
  'functionalitiesPage.collaboration.traceability.title': 'Traçabilité complète',
  'functionalitiesPage.collaboration.traceability.feature1': 'Tableau de bord partagé : voyez où en sont tous les dossiers',
  'functionalitiesPage.collaboration.traceability.feature2': 'Historique des modifications : qui a fait quoi et quand',

  // Reports Section
  'functionalitiesPage.reports.title': 'Historique & Rapports',
  'functionalitiesPage.reports.subtitle': 'Gardez une trace de vos dossiers et présentez vos résultats',
  'functionalitiesPage.reports.tracking.title': 'Suivi de vos candidatures',
  'functionalitiesPage.reports.tracking.feature1': 'Historique des dossiers déposés par client',
  'functionalitiesPage.reports.tracking.feature2': 'Montants obtenus enregistrés pour chaque dossier',
  'functionalitiesPage.reports.pdf.title': 'Rapports PDF',
  'functionalitiesPage.reports.pdf.feature1': 'Export avec votre logo et coordonnées de cabinet',
  'functionalitiesPage.reports.pdf.feature2': 'Liste des aides éligibles prête à envoyer au client',

  // Security Section
  'functionalitiesPage.security.title': 'Sécurité & Conformité',
  'functionalitiesPage.security.subtitle': 'Vos données protégées et conformes à la réglementation',
  'functionalitiesPage.security.hosting.title': 'Hébergement & Chiffrement',
  'functionalitiesPage.security.hosting.feature1': 'Chiffrement des données - Protection de vos informations sensibles',
  'functionalitiesPage.security.hosting.feature2': 'Hébergé sur Supabase (infrastructure SOC 2) - Serveurs dans l\'Union Européenne',
  'functionalitiesPage.security.compliance.title': 'Conformité & Audits',
  'functionalitiesPage.security.compliance.feature1': 'Conformité RGPD complète - Respect strict de la réglementation européenne',
  'functionalitiesPage.security.compliance.feature2': 'Pistes d\'audit détaillées - Traçabilité complète des accès',

  // Key Features Section
  'functionalitiesPage.keyFeatures.badge': 'Fonctionnalités clés',
  'functionalitiesPage.keyFeatures.title': 'Ce que vous pouvez faire avec Subvention360',
  'functionalitiesPage.keyFeatures.subtitle': 'Des outils simples et efficaces pour trouver et suivre vos financements',

  'functionalitiesPage.keyFeatures.clients.title': 'Fiches Clients',
  'functionalitiesPage.keyFeatures.clients.description': 'Créez un dossier client en moins de 30 secondes',
  'functionalitiesPage.keyFeatures.clients.feature1': 'Entreprise existante : données récupérées automatiquement via le SIRET',
  'functionalitiesPage.keyFeatures.clients.feature2': 'Projet de création : assistant IA qui guide pas à pas',
  'functionalitiesPage.keyFeatures.clients.feature3': 'Import en masse : chargez vos clients depuis Excel ou CSV',

  'functionalitiesPage.keyFeatures.assistant.title': 'Assistant IA',
  'functionalitiesPage.keyFeatures.assistant.description': 'Un conseiller virtuel pour vous accompagner',
  'functionalitiesPage.keyFeatures.assistant.feature1': 'Posez vos questions sur les aides et dispositifs',
  'functionalitiesPage.keyFeatures.assistant.feature2': 'Aide à la rédaction et à la compréhension des critères',
  'functionalitiesPage.keyFeatures.assistant.feature3': 'Guide interactif pour les projets de création d\'entreprise',

  'functionalitiesPage.keyFeatures.search.title': 'Recherche d\'Aides',
  'functionalitiesPage.keyFeatures.search.description': 'Trouvez les dispositifs adaptés à chaque client',
  'functionalitiesPage.keyFeatures.search.feature1': 'Trouve des résultats même sans les termes exacts',
  'functionalitiesPage.keyFeatures.search.feature2': 'Filtres par région, secteur, montant, type d\'aide',
  'functionalitiesPage.keyFeatures.search.feature3': 'Recherche par mots-clés métier',

  'functionalitiesPage.keyFeatures.identification.title': 'Identification Automatique',
  'functionalitiesPage.keyFeatures.identification.description': 'Les aides éligibles en quelques secondes',
  'functionalitiesPage.keyFeatures.identification.feature1': 'Analyse automatique du profil entreprise',
  'functionalitiesPage.keyFeatures.identification.feature2': 'Score d\'éligibilité de 0 à 100%',
  'functionalitiesPage.keyFeatures.identification.feature3': 'Classement par pertinence',

  'functionalitiesPage.keyFeatures.reportsEmail.title': 'Rapports & Envoi par Email',
  'functionalitiesPage.keyFeatures.reportsEmail.description': 'Documents professionnels prêts à partager',
  'functionalitiesPage.keyFeatures.reportsEmail.feature1': 'Export PDF avec votre logo et coordonnées',
  'functionalitiesPage.keyFeatures.reportsEmail.feature2': 'Envoi par email avec contenu généré par IA',
  'functionalitiesPage.keyFeatures.reportsEmail.feature3': 'Historique des envois et contacts mémorisés',

  'functionalitiesPage.keyFeatures.fileTracking.title': 'Suivi des Dossiers',
  'functionalitiesPage.keyFeatures.fileTracking.description': 'Pilotez vos missions de financement',
  'functionalitiesPage.keyFeatures.fileTracking.feature1': 'Tableau de bord visuel par étapes',
  'functionalitiesPage.keyFeatures.fileTracking.feature2': 'Déplacez les dossiers d\'une colonne à l\'autre',
  'functionalitiesPage.keyFeatures.fileTracking.feature3': 'Alertes sur les échéances proches',

  'functionalitiesPage.keyFeatures.teamwork.title': 'Travail en Équipe',
  'functionalitiesPage.keyFeatures.teamwork.description': 'Partagez les dossiers entre collaborateurs',
  'functionalitiesPage.keyFeatures.teamwork.feature1': 'Accès partagé aux fiches clients',
  'functionalitiesPage.keyFeatures.teamwork.feature2': 'Droits d\'accès par rôle (lecture, modification)',
  'functionalitiesPage.keyFeatures.teamwork.feature3': 'Historique des modifications',

  // Final CTA
  'functionalitiesPage.cta.title': 'Prêt à révolutionner votre accompagnement en financements publics ?',
  'functionalitiesPage.cta.subtitle': 'Rejoignez les cabinets qui optimisent déjà leur service subventions',
  'functionalitiesPage.cta.startNow': 'Commencer maintenant',
  'functionalitiesPage.cta.viewPricing': 'Voir les tarifs',
  'functionalitiesPage.cta.badge1': 'Solution complète',
  'functionalitiesPage.cta.badge2': 'Spécialisée conseil',
  'functionalitiesPage.cta.badge3': 'Sécurité garantie',
  'functionalitiesPage.cta.badge4': 'Support email inclus',
} as const;
